import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b6a8c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "field-error"
}
const _hoisted_2 = {
  key: 1,
  class: "field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendForm && _ctx.sendForm(...args))),
    class: "add-product-form"
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_Multiselect, {
        class: "product-select",
        modelValue: _ctx.form.product_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.product_id) = $event)),
        valueProp: "id",
        label: "name",
        mode: "single",
        delay: 150,
        options: _ctx.getProducts,
        filterResults: false,
        openDirection: "top",
        resolveOnLoad: false,
        placeholder: "Søk etter vare med varenummer, strekkode eller navn",
        onSelect: _ctx.focusAmount,
        searchable: true,
        addOptionOn: ['enter', 'tab'],
        onClear: _ctx.clearAmount
      }, null, 8, ["modelValue", "options", "onSelect", "onClear"]),
      (_ctx.form.errors.product_id)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.form.errors.product_id), 1))
        : _createCommentVNode("", true),
      (_ctx.form.errors.amount)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.form.errors.amount), 1))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      id: "addProductAmount",
      class: "amount",
      type: "number",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
      max: "255",
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectText && _ctx.selectText(...args)))
    }, null, 544), [
      [_vModelText, _ctx.form.amount]
    ]),
    _createVNode(_component_Button, {
      onClick: _ctx.sendForm,
      disabled: _ctx.form.processing || !_ctx.orderIsEditable || _ctx.actionsLocked,
      class: "add-button",
      color: "green",
      type: "submit"
    }, {
      default: _withCtx(() => [
        (_ctx.form.processing)
          ? (_openBlock(), _createBlock(_component_SvgIcon, {
              key: 0,
              class: "loading animate-spin",
              type: "mdi",
              path: _ctx.loadingIcon
            }, null, 8, ["path"]))
          : _createCommentVNode("", true),
        _createTextVNode("Legg til ")
      ]),
      _: 1
    }, 8, ["onClick", "disabled"])
  ], 32))
}